enum Source {
  NATIONAL = 'NATIONAL',
  LOCAL = 'LOCAL',
}

export default Source;
